import React, { Component } from 'react'
import LessonsPagination from '../../internal/LessonsPagination'
import SaveLesson from '../../internal/SaveLesson'

import PageMaker from './internal/PageMaker'

import { Wrapper, Main } from '../../styled'
import history from '../../../../../history'
import { Button } from 'antd'
import { withTranslation } from 'react-i18next'

class PageConstructor extends Component {
  render() {
    const {
      lesson: { pages, lessonId },
      rootPath,
      t,
      match
    } = this.props

    if (pages.length === 0) {
      history.push(`${rootPath}/page-builder`)
      return null
    }

    const isPageConstructor =
      match && match.path && match.path.includes('page-constructor')

    return (
      <Wrapper isPageConstructor={isPageConstructor}>
        <div style={{ paddingBottom: '5px' }}>
          <PageMaker rootPath={rootPath} />
        </div>

        <div className="p-footer">
          <div className="p-footer__inner p-footer__inner_justify">
            <div className="p-footer__col">
              <div className="p-footer__item">
                <LessonsPagination rootPath={rootPath} />
              </div>
            </div>
            <div className="p-footer__col">
              <div className="p-footer__item">
                <Button
                  className="rounded"
                  onClick={() =>
                    history.push(`${rootPath}/lesson-create/${lessonId}`)
                  }
                >
                  {t('buttons:back_to_lesson')}
                </Button>
              </div>
              <div className="p-footer__item">
                <SaveLesson />
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    )
  }
}

export default withTranslation('pageconstructor')(PageConstructor)
